/* This is used for our gtm integration */

export const gtmClickHandler = ({ name, data }) => {
  if (!name || !data) return

  // Initialize dataLayer if it doesn't exist (when GTM is not initialized)
  if (typeof window !== 'undefined' && !window.dataLayer) {
    window.dataLayer = []
  }

  if (window.dataLayer) {
    window.dataLayer.push({
      event: name,
      eventMsg: data
    })
  }
}

export const gtmNonInteraction = ({ action, category, label }) => {
  // Initialize dataLayer if it doesn't exist (when GTM is not initialized)
  if (typeof window !== 'undefined' && !window.dataLayer) {
    window.dataLayer = []
  }

  if (window.dataLayer) {
    window.dataLayer.push({
      event: {
        action,
        category,
        label,
        non_interaction: true
      }
    })
  }
}
